import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';
import '../styles/index.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const acceptEssentialCookies = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setShowBanner(false);
  };

  const handleClose = () => {
    // If user closes without choosing, they get essential only by default
    // This ensures we can still get basic analytics while being privacy-friendly
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      localStorage.setItem('cookieConsent', 'essential');
    }
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <p>
          We use cookies to enhance your experience, analyze traffic, and personalize content.
          We may share information about your use of this website with our social media,
          advertising, and analytics partners.
        </p>
        <div className="cookie-consent-buttons">
          <button
            className="cookie-consent-btn cookie-consent-essential"
            onClick={acceptEssentialCookies}
          >
            Essential Only
          </button>
          <button
            className="cookie-consent-btn cookie-consent-accept"
            onClick={acceptCookies}
          >
            Accept All
          </button>
        </div>
        <button
          className="btn-close-shared absolute -top-[5px] right-[8px]"
          onClick={handleClose}
          aria-label="Close cookie consent"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;